import React from 'react';
import Input from '../componenti/input/Simple';
import InputProv from '../componenti/input/Provincia';

const Certificazione = ({
    anteprima, 
    inputValues,
    handleOnChange,
    }) => {
    return (
        <>
            <div style={{padding:'20px'}}>DICHIARA</div>
            di essere in qualità di studente presso
            <span>
            {anteprima ? <span><span> </span> {inputValues.tipoIstituto.valore} <span> </span></span> : 
            <select 
                name="tipoIstituto"
                value={inputValues.tipoIstituto.valore}
                onChange={handleOnChange}
                id={inputValues.tipoIstituto.stile}
                >
                <option value="" selected disabled hidden>{inputValues.tipoIstituto.placeholder}</option>
                <option value="la scuola">la scuola</option>
                <option value="l'università">l'università</option>
            </select>
            }
            </span>
            <Input
                anteprima={anteprima} 
                inputValues={inputValues}
                handleOnChange={handleOnChange}
                inputName='nomeIstituto'
            />
            di
            <Input
                anteprima={anteprima} 
                inputValues={inputValues}
                handleOnChange={handleOnChange}
                inputName='citStudente'
            />
            <InputProv
                anteprima={anteprima} 
                inputValues={inputValues}
                handleOnChange={handleOnChange}
                inputName='provCitStudente'
            />
        </>
        );
    }

export default Certificazione;